import { DataTable, DataTableData } from "@/src/components/ui/data-table";
import { useEffect, useState } from "react";
import { TopLevelRegion } from "./model";
import { useFetch } from "@/src/lib/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import { useNavigate } from "react-router-dom";
import { useSearch, usePageSize } from "./state";
import { extractFromMultiName } from "./utils";

export function TopLevelRegionsTable() {
  const [tlrs, setTlrs] = useState<DataTableData<TopLevelRegion>>({
    data: [],
    total: 1,
    pagination: { page: 1, pageSize: 1 },
  });
  const [page, setPage] = useState(1);

  const navigate = useNavigate();

  const search = useSearch();
  const pageSize = usePageSize();

  const { fetch } = useFetch();

  useEffect(() => {
    const fetchTlrs = (page: number) =>
      fetch<DataTableData<TopLevelRegion>>(
        `/api/locations/top-level-regions?page=${page}&pageSize=${pageSize}&filter=${search}`,
      );

    fetchTlrs(page).then((data) => {
      setTlrs(data);
    });
  }, [page, search, pageSize]);

  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-md bg-white border">
        <DataTable
          columns={topLevelRegionsColumns}
          pagination={tlrs}
          data={tlrs.data}
          onPageClick={setPage}
          onRowClick={(r) => navigate(`/locations/top-level-regions/${r.id}`)}
        />
      </div>
    </div>
  );
}

export const topLevelRegionsColumns: ColumnDef<TopLevelRegion>[] = [
  {
    header: "Name",
    accessorFn: (r) => extractFromMultiName(r.names),
  },
];
